import React from 'react';
import PropTypes from 'prop-types';

import {OEIconButton} from '../../controls/oe-button';
import {OEIconButtonGroup} from '../../controls/oe-button-group';
import OETextField from '../../controls/oe-text-field';
import {OEObjectModelValueCellBtnIds, OEObjectModelValueIcons} from '../oe-object-model-value-edit-model';
import OEObjectModelValueCell from './oe-object-model-value-cell';

export default class OEObjectModelStringArrayValueCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onButtonPressed = this.onButtonPressed.bind(this);
        this.onDumpButtonPressed = this.onDumpButtonPressed.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
    }

    onChange(value) {
        if(this.props.onChange)   this.props.onChange(this, this.props.name, value);
    }

    render()    {

        let elements;
        if(Array.isArray(this.props.value)) {
            elements = [];

            for(let i = 0; i < this.props.value.length; ++i)    {
                let text = this.props.value[i];
                if(typeof(text) !== 'string')   text = '';

                elements.push(
                    <div 
                        key={i}
                        className="array-element"
                    >
                        <OETextField
                            index={i}
                            disabled={this.props.disabled}
                            value={text}
                            clearButton={false}
                            onChange={this.onTextChange}
                        />
                        <OEIconButton
                            index={i}
                            disabled={this.props.disabled}
                            icon={OEObjectModelValueIcons.dumpArrayEntry}
                            onPressed={this.onDumpButtonPressed}
                        />
                    </div>
                );
            }
        }

        return (
            <OEObjectModelValueCell {...this.props}>
                
                <OEIconButtonGroup
                    buttons={[
                        {
                            id: OEObjectModelValueCellBtnIds.newArrayEntry,
                            icon: OEObjectModelValueIcons.newArrayEntry,
                            disabled: this.props.disabled
                        }
                    ]}
                    onPressed={this.onButtonPressed}
                />

                {elements === undefined ? null :
                    <div className="array-container">
                        {elements}
                    </div>
                }

            </OEObjectModelValueCell>
        );
    }

    onButtonPressed(sender, id) {
        if(id === OEObjectModelValueCellBtnIds.newArrayEntry)   {
            let value = Array.isArray(this.props.value) ? [...this.props.value, ''] : [''];
            this.onChange(value);
        }
    }

    onDumpButtonPressed(event, sender) {
        let i = sender.props.index;
        if(!Array.isArray(this.props.value) || i < 0 || i >= this.props.value.length)   return;
        let value = [...this.props.value];
        value.splice(i, 1);
        this.onChange(value);
    }

    onTextChange(sender, value)    {
        let i = sender.props.index;
        if(!Array.isArray(this.props.value) || i < 0 || i >= this.props.value.length)   return;
        let value_ = [...this.props.value];
        let value__ = typeof(value) === 'string' ? value : '';
        if(value_[i] === value__) return;
        value_[i] = value__;
        this.onChange(value_);
    }
};

OEObjectModelStringArrayValueCell.defaultProps = Object.assign({
    disabled:                   false,
    allowUndefined:             false
}, OEObjectModelValueCell.defaultProps);

OEObjectModelStringArrayValueCell.propTypes = Object.assign({
    disabled:                   PropTypes.bool,
    allowUndefined:             PropTypes.bool,
    value:                      PropTypes.array
}, OEObjectModelValueCell.propTypes);